module.exports = __webpack_public_path__ + "img/design_blockDiagram_evalBoard.39b01705.png";